/** Shared Studio / Plateforme home routes — single source for App + AppShell. */

/** Organisation › Machine gates › Coding agents (former /studio/agent-control). */
export const CODE_AGENTS_GATE_ROUTE = '/studio/gates?section=code-agents'

export type StudioHomePermissions = {
  canBuildRecipes: boolean
  canBuildDeploy: boolean
  canBuildExternalControl: boolean
}

/**
 * Atterrissage quand l'utilisateur clique Studio.
 * Prefer Calisto chat when recipes are writable; else Organisation › Machine gates; else Run.
 */
export function resolveStudioHomeRoute({
  canBuildRecipes,
  canBuildExternalControl,
}: Pick<
  StudioHomePermissions,
  'canBuildRecipes' | 'canBuildExternalControl'
>): string {
  if (canBuildRecipes) return '/studio/chat'
  if (canBuildExternalControl) return CODE_AGENTS_GATE_ROUTE
  return '/run/chat'
}

/**
 * Fallback for blocked /studio/* access (Plateforme org surfaces).
 * Plateforme is org catalogues only (LLM today) — agent keys/data live under Agents.
 */
export function resolvePlateformeHomeRoute({
  canBuildDeploy,
  canBuildExternalControl,
  canBuildRecipes,
}: StudioHomePermissions): string {
  if (canBuildDeploy) return '/studio/llm'
  if (canBuildRecipes) return '/studio/chat'
  if (canBuildExternalControl) return CODE_AGENTS_GATE_ROUTE
  return '/run/chat'
}
